import '../styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphBreadcrumbContainer } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbContainer';
import type { GraphBreadcrumbProps } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbProps';
import type { CompareModeBreadcrumb } from 'components/Graph/GraphBreadcrumbs/helpers/buildBreadcrumbs';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { compareSnapshot } from 'components/Graph/commands/compareSnapshot';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';

export const getCompareModeBreadcrumbText = (
  breadcrumb: CompareModeBreadcrumb,
  msg: AppTranslations,
): string =>
  `${msg.canvasGraph.breadcrumbs.compareMode.label}:
   ${breadcrumb.snapshotName}
   ${msg.canvasGraph.breadcrumbs.compareMode.vs}
   ${breadcrumb.snapshotToCompareName}`;

export const CompareModeBreadcrumbItem: FC<
  GraphBreadcrumbProps<CompareModeBreadcrumb>
> = (props) => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  return (
    <GraphBreadcrumbContainer
      containerStyle='extra'
      onClick={() => {
        ctxProps.dispatch(showSidePanel, { contentId: 'compareSnapshot' });
      }}
      onRemoveButtonClick={() => {
        ctxProps.dispatch(compareSnapshot, { snapshotToCompareId: null });
      }}
      removalIndicated={props.removalIndicated}
    >
      {getCompareModeBreadcrumbText(props.content, msg)}
    </GraphBreadcrumbContainer>
  );
};
